// Intentionally global
___export = require('./../../lib/src-server/azure-server').setDirName(__dirname).serve(require('./../../lib/src-server/example-function-error-after-async').main);
module.exports = ___export;


//////////////////
// WEBPACK FOOTER
// ./deployment/example-function-error-after-async/build.source.js
// module id = 276
// module chunks = 12